import { memo } from 'react'
import { observer } from 'mobx-react'
import Typography from '@mui/material/Typography'
import { Box, Theme } from '@mui/material'
import useEmotionStyles from 'hooks/useEmotionStyles'
import * as CSSTypes from 'csstype'
import PersonIcon from '@mui/icons-material/Person'
import PeopleAltIcon from '@mui/icons-material/PeopleAlt'

import { useData } from '../../stores/utils/hooks/useData'
import { isDDFSmavaConfig } from 'config/utils/config'
import { useRootStore } from 'stores/utils/hooks/useRootStore'

const PREFIX_SECOND_DEBTOR = '2.'
const PREFIX_FIRST_DEBTOR = '1.'
const SUFFIX_DEBTOR = ' Kreditnehmer'

type Props = {
  isSecondary?: boolean
}

const styles = (theme: Theme) => ({
  headline: {
    fontWeight: 'normal'
  },
  headlineSmava: {
    textAlign: 'left' as CSSTypes.Property.TextAlign
  },
  typographySecondDebator: {
    marginTop: theme.spacing(1),
    fontWeight: 700
  },
  headlineWrapper: {
    display: 'flex',
    textTransform: 'uppercase' as CSSTypes.Property.TextTransform,
    alignItems: 'center',
    padding: '8px 0',
    marginBottom: '16px'
  },
  headlineSeparator: {
    border: `0.5px solid ${theme.palette.grey[300]}`,
    flex: 1,
    marginLeft: `${theme.spacing(2)}`,
    height: 0
  },
  iconWrapper: {
    marginRight: '4px'
  }
})

const TwoDebtorHeadline = observer(({ isSecondary }: Props) => {
  const { data } = useData()
  const {
    rootStore: { page }
  } = useRootStore()

  const {
    typographySecondDebator,
    headlineWrapper,
    headlineSeparator,
    iconWrapper
  } = useEmotionStyles(styles)
  const {
    debtors: {
      count,
      primary: {
        personal: { firstname: firstNamePrimary, lastname: lastNamePrimary }
      },
      secondary: {
        personal: { firstname: firstNameSecondary, lastname: lastNameSecondary }
      }
    }
  } = data

  const isDebtorNameComplete =
    firstNamePrimary &&
    lastNamePrimary &&
    firstNameSecondary &&
    lastNameSecondary

  if (!isDDFSmavaConfig(page.config.name) || count < 2) {
    return null
  }
  return (
    <Typography className={typographySecondDebator} variant="body2">
      <Box className={headlineWrapper}>
        <span className={iconWrapper}>
          {isSecondary ? <PeopleAltIcon /> : <PersonIcon />}
        </span>
        {isDebtorNameComplete ? (
          <>
            {isSecondary
              ? `${firstNameSecondary} ${lastNameSecondary}`
              : `${firstNamePrimary} ${lastNamePrimary}`}
          </>
        ) : (
          <>
            {isSecondary ? `${PREFIX_SECOND_DEBTOR}` : PREFIX_FIRST_DEBTOR}
            {SUFFIX_DEBTOR}
          </>
        )}
        <Box className={headlineSeparator}></Box>
      </Box>
    </Typography>
  )
})

export default memo(TwoDebtorHeadline)
